import React from 'react';
import { useFormContext } from 'react-hook-form';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import strings from 'strings';
import { FPActionButton, TextBox, When } from 'UI/components/atoms';
import { Endpoints } from 'UI/constants/endpoints';
import { SendoverStatus, UIStatus } from 'UI/constants/status';

import { COPIES, FORM_FIELDS_MAP } from './SendoverReasonsFields.constants';
import { VerticalStack } from './SendoverReasonsFields.styled';
import { getSelectedReasonIds } from './SendoverReasonsFields.utils';

export const SendoverReasonsFields = () => {
  const { errors, getValues, register } = useFormContext();
  const { state, refreshData } = useFetchWithStatusV2({
    endpoint: `${Endpoints.SendoutReasons}?statusId=${SendoverStatus.Active}`
  });

  const validateReasons = () =>
    getSelectedReasonIds(getValues(FORM_FIELDS_MAP.SendoverReasons.key)).length > 0 ||
    COPIES.errors.reasons;

  const hasError = Boolean(errors[FORM_FIELDS_MAP.SendoverReasonsGuard.key]);
  const sendoverReasons = state.status === UIStatus.Success ? state.results : [];
  const hasCatalogError = state.status === UIStatus.Error || state.status === UIStatus.Empty;

  return (
    <VerticalStack>
      <Typography variant="body2">{COPIES.subtitle}</Typography>

      <FormControl component="fieldset" error={hasError}>
        <FormGroup>
          <When condition={state.status === UIStatus.Loading}>
            <CircularProgress size={24} />
          </When>

          <When condition={hasCatalogError}>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
              <FPActionButton
                onClick={refreshData}
                text={strings.shared.ui.retry}
                variant="outlined"
              />
              <Typography color="error" variant="body2">
                {COPIES.errors.catalogUnavailable}
              </Typography>
            </Box>
          </When>

          {sendoverReasons.map(reason => (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  name={FORM_FIELDS_MAP.SendoverReasons.key}
                  value={reason.id}
                  inputRef={register()}
                />
              }
              key={reason.id}
              label={reason.title}
            />
          ))}

          <input
            ref={register({ validate: validateReasons })}
            type="hidden"
            name={FORM_FIELDS_MAP.SendoverReasonsGuard.key}
          />

          <When condition={hasError}>
            <FormHelperText>
              {errors[FORM_FIELDS_MAP.SendoverReasonsGuard.key]?.message}
            </FormHelperText>
          </When>
        </FormGroup>
      </FormControl>

      <TextBox
        inputRef={register()}
        label={COPIES.labels.comments}
        multiline
        name={FORM_FIELDS_MAP.Comments.key}
        placeholder={COPIES.labels.comments}
      />
    </VerticalStack>
  );
};
